/**
 * APT Conversion Program feature flags.
 * All boolean gates require the literal string `true`.
 */

export const TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED_ENV =
  'TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED';
export const VITE_TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED_ENV =
  'VITE_TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED';
export const EVENT_EXPRESS_REGISTER_ENABLED_ENV =
  'EVENT_EXPRESS_REGISTER_ENABLED';
export const VITE_EVENT_EXPRESS_REGISTER_ENABLED_ENV =
  'VITE_EVENT_EXPRESS_REGISTER_ENABLED';
export const PROVIDER_APPLY_LITE_ENABLED_ENV = 'PROVIDER_APPLY_LITE_ENABLED';
export const VITE_PROVIDER_APPLY_LITE_ENABLED_ENV =
  'VITE_PROVIDER_APPLY_LITE_ENABLED';
export const CONVERSION_DOORS_NAV_ENABLED_ENV =
  'CONVERSION_DOORS_NAV_ENABLED';
export const VITE_CONVERSION_DOORS_NAV_ENABLED_ENV =
  'VITE_CONVERSION_DOORS_NAV_ENABLED';
export const NATIVE_EVENT_RANK_BOOST_ENABLED_ENV =
  'NATIVE_EVENT_RANK_BOOST_ENABLED';
export const EXTERNAL_ALERT_CAPTURE_ENABLED_ENV =
  'EXTERNAL_ALERT_CAPTURE_ENABLED';
export const VITE_EXTERNAL_ALERT_CAPTURE_ENABLED_ENV =
  'VITE_EXTERNAL_ALERT_CAPTURE_ENABLED';
export const EVENT_CARD_DISPLAY_NORMALIZE_ENABLED_ENV =
  'EVENT_CARD_DISPLAY_NORMALIZE_ENABLED';
export const VITE_EVENT_CARD_DISPLAY_NORMALIZE_ENABLED_ENV =
  'VITE_EVENT_CARD_DISPLAY_NORMALIZE_ENABLED';
export const VITE_EVENT_CARD_HIERARCHY_ENABLED_ENV =
  'VITE_EVENT_CARD_HIERARCHY_ENABLED';
export const TRAINING_ALERTS_DIGEST_ENABLED_ENV =
  'TRAINING_ALERTS_DIGEST_ENABLED';
export const TRAINING_ALERTS_NUDGE_ENABLED_ENV =
  'TRAINING_ALERTS_NUDGE_ENABLED';
export const VITE_TRAINING_ALERTS_NUDGE_ENABLED_ENV =
  'VITE_TRAINING_ALERTS_NUDGE_ENABLED';
export const FIRST_WIN_ACTIVATION_ENABLED_ENV = 'FIRST_WIN_ACTIVATION_ENABLED';
export const VITE_FIRST_WIN_ACTIVATION_ENABLED_ENV =
  'VITE_FIRST_WIN_ACTIVATION_ENABLED';
export const FOR_OFFICERS_LANDING_ENABLED_ENV = 'FOR_OFFICERS_LANDING_ENABLED';
export const VITE_FOR_OFFICERS_LANDING_ENABLED_ENV =
  'VITE_FOR_OFFICERS_LANDING_ENABLED';
export const FOR_PROFESSIONALS_LANDING_ENABLED_ENV =
  'FOR_PROFESSIONALS_LANDING_ENABLED';
export const VITE_FOR_PROFESSIONALS_LANDING_ENABLED_ENV =
  'VITE_FOR_PROFESSIONALS_LANDING_ENABLED';
export const WRITE_FOR_APT_LANDING_ENABLED_ENV = 'WRITE_FOR_APT_LANDING_ENABLED';
export const VITE_WRITE_FOR_APT_LANDING_ENABLED_ENV =
  'VITE_WRITE_FOR_APT_LANDING_ENABLED';

export function isTrainingEventGeoAlertsGuestEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED_ENV] === 'true';
}

export function isViteTrainingEventGeoAlertsGuestEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_TRAINING_EVENT_GEO_ALERTS_GUEST_ENABLED_ENV] === 'true';
}

export function isEventExpressRegisterEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[EVENT_EXPRESS_REGISTER_ENABLED_ENV] === 'true';
}

export function isViteEventExpressRegisterEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_EVENT_EXPRESS_REGISTER_ENABLED_ENV] === 'true';
}

export function isProviderApplyLiteEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[PROVIDER_APPLY_LITE_ENABLED_ENV] === 'true';
}

export function isViteProviderApplyLiteEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_PROVIDER_APPLY_LITE_ENABLED_ENV] === 'true';
}

export function isConversionDoorsNavEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[CONVERSION_DOORS_NAV_ENABLED_ENV] === 'true';
}

export function isViteConversionDoorsNavEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_CONVERSION_DOORS_NAV_ENABLED_ENV] === 'true';
}

export function isNativeEventRankBoostEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[NATIVE_EVENT_RANK_BOOST_ENABLED_ENV] === 'true';
}

export function isExternalAlertCaptureEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[EXTERNAL_ALERT_CAPTURE_ENABLED_ENV] === 'true';
}

export function isViteExternalAlertCaptureEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_EXTERNAL_ALERT_CAPTURE_ENABLED_ENV] === 'true';
}

export function isEventCardDisplayNormalizeEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[EVENT_CARD_DISPLAY_NORMALIZE_ENABLED_ENV] === 'true';
}

export function isViteEventCardDisplayNormalizeEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_EVENT_CARD_DISPLAY_NORMALIZE_ENABLED_ENV] === 'true';
}

export function isViteEventCardHierarchyEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_EVENT_CARD_HIERARCHY_ENABLED_ENV] === 'true';
}

export function isTrainingAlertsDigestEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[TRAINING_ALERTS_DIGEST_ENABLED_ENV] === 'true';
}

export function isTrainingAlertsNudgeEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[TRAINING_ALERTS_NUDGE_ENABLED_ENV] === 'true';
}

export function isViteTrainingAlertsNudgeEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_TRAINING_ALERTS_NUDGE_ENABLED_ENV] === 'true';
}

export function isFirstWinActivationEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[FIRST_WIN_ACTIVATION_ENABLED_ENV] === 'true';
}

export function isViteFirstWinActivationEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_FIRST_WIN_ACTIVATION_ENABLED_ENV] === 'true';
}

export function isForOfficersLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[FOR_OFFICERS_LANDING_ENABLED_ENV] === 'true';
}

export function isViteForOfficersLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_FOR_OFFICERS_LANDING_ENABLED_ENV] === 'true';
}

/** Landing is reachable only when API + Vite flags are both on. */
export function isForOfficersLandingPublicSurfaceEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return isForOfficersLandingEnabled(env) && isViteForOfficersLandingEnabled(env);
}

export function isForProfessionalsLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[FOR_PROFESSIONALS_LANDING_ENABLED_ENV] === 'true';
}

export function isViteForProfessionalsLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_FOR_PROFESSIONALS_LANDING_ENABLED_ENV] === 'true';
}

export function isForProfessionalsLandingPublicSurfaceEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return (
    isForProfessionalsLandingEnabled(env) &&
    isViteForProfessionalsLandingEnabled(env)
  );
}

export function isWriteForAptLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[WRITE_FOR_APT_LANDING_ENABLED_ENV] === 'true';
}

export function isViteWriteForAptLandingEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return env[VITE_WRITE_FOR_APT_LANDING_ENABLED_ENV] === 'true';
}

export function isWriteForAptLandingPublicSurfaceEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  return isWriteForAptLandingEnabled(env) && isViteWriteForAptLandingEnabled(env);
}
